export default "__VITE_ASSET__vxg4cIBH__"